class InfiniteScroll extends HTMLElement {
    initialize() {
        this.maxScroll = 4;
        this.loadLink = this.querySelector('[data-load-link]');
        this.addEventListener('click', this.handleLoadLinkClick.bind(this));

        if (this.dataset.autoScroll && this.loadLink) {
            this.intersectionObserver = null;
            this.registerIntersectionObserver();
        }
    }

    disconnectedCallback() {
        this.removeEventListener('click', this.handleLoadLinkClick);
        if (this.intersectionObserver) {
            this.intersectionObserver.unobserve(this.loadLink);
        }
    }

    registerIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver(entries => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    let scrolled = this.loadLink.dataset.scrolled ? parseInt(this.loadLink.dataset.scrolled) : 0;
                    const canClick = scrolled < this.maxScroll || this.loadLink.dataset.infiniteScroll;
                    if (canClick) {
                        this.loadLink.click();
                    }
                }
            });
        }, {rootMargin: '500px'});

        this.intersectionObserver.observe(this.loadLink);
    }

    handleLoadLinkClick(event) {
        if (!event.target.dataset.loadLink) {
            return;
        }

        event.preventDefault();

        this.loadProducts(event.target);
    }

    loadProducts(loadLink) {
        const url = loadLink.getAttribute('href');
        this.classList.add('loading');

        fetch(`${url}&section_id=${this.getProductGrid().dataset.id}`)
            .then(response => response.text())
            .then(html => this.renderProductCards(html, url, loadLink))
            .finally(() => this.classList.remove('loading'));
    }

    getProductGrid() {
        return document.getElementById('product-grid');
    }

    renderProductCards(html, url, loadLink) {
        const subtree = new DOMParser().parseFromString(html, 'text/html');
        const productGrid = this.getProductGrid();
        const isPreviousLink = loadLink.dataset.previousLink;
        // We need to append as html even if its less performant because
        // otherwise the image sizes from srcset won't be properly selected by safari
        const whereToInsert = isPreviousLink ? 'afterbegin' : 'beforeend';
        // eslint-disable-next-line no-unsanitized/method
        productGrid.insertAdjacentHTML(whereToInsert, subtree.querySelector('#product-grid').innerHTML);
        if (this.dataset.updateHistory) {
            this.changeHistory(url);
        }

        const newloadLink = subtree.querySelector(isPreviousLink ? '[data-previous-link]' : '[data-next-link]');
        if (!newloadLink) {
            loadLink.removeAttribute('href');
            this.classList.add('hidden');
        } else {
            loadLink.setAttribute('href', newloadLink.getAttribute('href'));
            this.classList.remove('hidden');
            if (loadLink.dataset.scrolled && loadLink.dataset.scrolled > this.maxScroll && !loadLink.dataset.infiniteScroll) {
                loadLink.dataset.infiniteScroll = 'true';
            }
            loadLink.dataset.scrolled += parseInt(loadLink.dataset.scrolled) + 1;
        }

        document.dispatchEvent(new CustomEvent('productListCardsRendered'));
    }

    changeHistory(url) {
        window.history.replaceState({}, '', url);
        window.lastCollectionUrl = url;
    }
}

customElements.define('infinite-scroll', InfiniteScroll);

customElements.define('infinite-scroll-initializer', class extends HTMLElement {
    connectedCallback() {
        if (typeof this.parentElement.initialize === 'function') {
            this.parentElement.initialize();
        }
    }
});